import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f04befc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-white/90 dark:tw-bg-black/90" }
const _hoisted_2 = { class: "tw-relative tw-flex-1 tw-overflow-y-auto tw-overflow-x-hidden tw-px-4 tw-py-6" }
const _hoisted_3 = { class: "tw-flex tw-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "icon-circle tw-bg-red-50 dark:tw-bg-slate-900"
}
const _hoisted_5 = {
  key: 1,
  class: "icon-circle tw-bg-green-50 dark:tw-bg-slate-900"
}
const _hoisted_6 = {
  key: 2,
  class: "icon-circle tw-bg-deep-orange-600 dark:tw-bg-slate-900"
}
const _hoisted_7 = {
  key: 3,
  class: "icon-circle tw-bg-accent"
}
const _hoisted_8 = {
  key: 4,
  class: "icon-circle tw-bg-deep-orange-50 dark:tw-bg-slate-900"
}
const _hoisted_9 = { class: "tw-text-md tw-mb-1 tw-font-medium tw-leading-tight tw-text-black dark:tw-text-white lg:tw-text-lg lg:tw-leading-tight" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "tw-item-center tw-flex tw-justify-end tw-border-t tw-p-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExclamationTriangle = _resolveComponent("ExclamationTriangle")!
  const _component_Check = _resolveComponent("Check")!
  const _component_TablerLock = _resolveComponent("TablerLock")!
  const _component_IconEdit = _resolveComponent("IconEdit")!
  const _component_StudioButton = _resolveComponent("StudioButton")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "fly-from-bottom",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          "data-testid": "studio-confirmation-dialog",
          class: _normalizeClass(`tw-m-2 tw-flex tw-max-h-full tw-min-w-[300px] tw-flex-col tw-rounded-xl tw-border tw-bg-white tw-shadow-2xl dark:tw-bg-black ${_ctx.widthClass}`)
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!_ctx.hideIcon)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.type === 'error')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_ExclamationTriangle, { class: "tw-h-6 tw-w-6 tw-text-red-500" })
                        ]))
                      : (_ctx.type === 'success')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_Check, { class: "tw-h-6 tw-w-6 tw-text-green-500" })
                          ]))
                        : (_ctx.type === 'lock')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createVNode(_component_TablerLock, { class: "tw-h-6 tw-w-6 tw-text-white" })
                            ]))
                          : (_ctx.type === 'edit')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createVNode(_component_IconEdit, { class: "tw-h-6 tw-w-6" })
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(_component_ExclamationTriangle, { class: "tw-h-6 tw-w-6 tw-text-deep-orange-500" })
                              ]))
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(['tw-pl-4', { 'tw-pl-0': _ctx.hideIcon }])
              }, [
                _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.heading), 1),
                _createElementVNode("p", {
                  class: "!tw-mb-0 tw-text-sm tw-text-slate-500",
                  innerHTML: _ctx.message
                }, null, 8, _hoisted_10)
              ], 2)
            ])
          ]),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true),
          (_ctx.showFooter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.secondaryActionTitle)
                  ? (_openBlock(), _createBlock(_component_StudioButton, {
                      key: 0,
                      trackingId: "confirmation-dialog-secondary-action",
                      variant: "outline",
                      disabled: _ctx.actionsDisabled,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('secondaryAction')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.secondaryActionTitle), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.primaryActionTitle)
                  ? (_openBlock(), _createBlock(_component_StudioButton, {
                      key: 1,
                      trackingId: "confirmation-dialog-primary-action",
                      variant: "filled",
                      type: "submit",
                      class: "tw-ml-2",
                      disabled: _ctx.actionsDisabled || _ctx.isPrimaryActionButtonDisabled,
                      disabledReason: _ctx.primaryActionDisabledReason,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('primaryAction')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.primaryActionTitle), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "disabledReason"]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "confirmation-dialog-additional-ctas", {}, undefined, true)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _: 3
  }))
}